module.exports = __webpack_public_path__ + "static/media/human-resources-icon.ab11c974.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/human-resources-icon.svg
// module id = 1922
// module chunks = 0